import { Observable } from "rxjs";
import { InjectorInstance } from "src/app/services/global/global.service";
import { IContextData, IDataContextBucket } from "./data-context-repository.models";
import { DataContextBucketRepositoryService } from "./data-context-repository.service";



export interface ContextConstructor<T> {
    new(bucket: IDataContextBucket): T;
}

export interface IContext {
    handleEvent(event: any): void;
    readonly id: string;
    readonly data: IContextData;
    saveData(data: any): void;
    sendEvent(type: any, metadata: any);
}


export abstract class AbstractDataContext<T extends IContextData> implements IContext {

    bucket: IDataContextBucket;

    get data(): T {
        return this.bucket.getContextData(this.id);
    }

    get data$(): Observable<T> {
        return this.bucket.getContextData$(this.id);
    }

    constructor(public id: string) {
        this.bucket = InjectorInstance.get(DataContextBucketRepositoryService);
    }

    saveData(data: T): void {
        this.bucket.saveContextData(this.id, data);
    }

    removeData() {
        this.bucket.removeContextData(this.id);
    }

    abstract sendEvent(type: any, metadata: any);


    abstract handleEvent(event: any): void;


}
